import smoothscroolPolyfill from "smoothscroll-polyfill";
import smoothScrollIntoView from "smooth-scroll-into-view-if-needed";
smoothscroolPolyfill.polyfill();
/**
 * 元素滚动到可视区域，暂时只支持类名
 * @author yangyongheng
 * @date 2019-01-31
 * @default auto
 * @param {("auto" | "smooth")} [behavior]
 */
export function scrollIntoView(query) {
    const node = document.querySelector(query);
    node && smoothScrollIntoView(node, {
        behavior: "smooth",
        block: "center",
        inline: "center",
    });
}
/**
 * 元素滚动到可视区域，暂时只支持类名
 * @author yangyongheng
 * @date 2019-01-31
 * @default auto
 * @param {("auto" | "smooth")} [behavior]
 */
export function scrollIntoViewIfNeeded(query) {
    const node = document.querySelector(query);
    node && smoothScrollIntoView(node, {
        behavior: "smooth",
        block: "center",
        inline: "center",
        scrollMode: "if-needed",
    });
}
/**
 * 数据格式转化
 * @private
 * @param {number[]} datas
 * @returns {Array<{ year: string; children: TimelineComplexDate }>}
 */
export function dateFormat(datas) {
    return datas.map((date) => {
        const day = date.day;
        const all = [date.year, date.month, date.day].filter(item => item !== "").join("-");
        const key = date.key;
        return {
            key,
            normal: `${day}日`,
            hover: `${day}日`,
            active: `${day}日`,
            miniNormal: all,
            miniHover: all,
            miniActive: all,
            url: "",
        };
    });
}
/**
 * 数据格式转化
 * @private
 * @param {number[]} datas
 * @returns {Array<{ year: string; children: TimelineComplexDate }>}
 */
export function dateFormatForMonth(datas) {
    let sign = "";
    return datas.map((date) => {
        const month = date.month;
        const all = [date.year, date.month, date.day].filter(item => item !== "").join("-");
        const key = date.key;
        if (sign !== month) {
            sign = month;
            return {
                key,
                normal: `${month}月`,
                hover: `${month}月`,
                active: `${month}月`,
                miniNormal: all,
                miniHover: all,
                miniActive: all,
                url: "",
            };
        }
        return {
            key,
            normal: "",
            hover: `${month}月`,
            active: `${month}月`,
            miniNormal: all,
            miniHover: all,
            miniActive: all,
            url: "",
        };
    });
}
/**
 * 数据格式转化
 * @private
 * @param {number[]} datas
 * @returns {Array<{ year: string; children: TimelineComplexDate }>}
 */
export function dateFormatForYear(datas) {
    let sign = "";
    return datas.map((date) => {
        const month = date.month;
        const year = date.year;
        const all = [date.year, date.month, date.day].filter(item => item !== "").join("-");
        const key = date.key;
        if (sign !== month) {
            sign = month;
            return {
                key,
                normal: year,
                hover: year,
                active: year,
                miniNormal: all,
                miniHover: all,
                miniActive: all,
                url: "",
            };
        }
        return {
            key,
            normal: year,
            hover: year,
            active: year,
            miniNormal: all,
            miniHover: all,
            miniActive: all,
            url: "",
        };
    });
}
//# sourceMappingURL=utils.js.map